<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID"  ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>
      <div class="MobelBox" v-if="addType">
        <div class="write-txt">
          <p class="write-title">类型名称<span>*</span></p>
          <div class="write-text">
            <textarea placeholder="最多输入500个中/英、数字和特殊符号" v-model="addObj.name"></textarea>
            <span>最多输入500个中/英、数字和特殊符号</span>
          </div>
        </div>

        <div class="write-btnBox">
          <button class="btn btn-save" @click="saveSub">保存</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <img src="~@/assets/images/icon-add.png" alt="">
            <p>添加类型</p>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p>
                <el-switch
                  @change="switchChange(item)"
                  v-model="item.publish_status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch>
              </p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p>
                <button title="修改" class="btn btn-revise" @click="buildSub(item)"></button>
                <button title="删除" class="btn btn-remove" @click="removeShow(item)"></button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      
    </div>

    <div class="msgBox" v-if="removeType">
      <div class="contv">
        <p class="title">是否确定删除？</p>
        <div class="btnBox">
          <button class="btn btn-close" @click="ModelHide('remove')">取消</button>
          <button class="btn btn-sub" @click="removeSub">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getUploadToken, getPracticeTypeList,getPracticeTypeDetail,savePracticeType,updatePracticeTypeStatus,delPracticeType } from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "examType",
  data() {
    return {
      navId:'3',
      childrenID:'3-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'类型名称'},
        {id:3,title:'状态'},
        {id:4,title:'添加时间'},
        {id:5,title:'操作'},
      ],
      dataList:[
      ],
      addType:'',
      removeType:false,
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        name:'',
      },
      totalPage:0,
      removeID:'',
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.getList();
    this.getToken();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      };
    },

    async getList(){
      var that = this;
      try {
        const response = await getPracticeTypeList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.publish_status==0){
              item.publish_status=false
            } else {
              item.publish_status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    addSub(){
      var that = this;
      this.addType = 'add';
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getPracticeTypeDetail({id:e.id},this.token);
        if(response.code == 200){
          that.addType = 'edit';
          that.addObj = {
            name:response.data.name,
            id:e.id
          }
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delPracticeType({id:this.removeID},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.getList();
          that.ModelHide('remove');       
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    ModelHide(type){
      var that = this;
      if(type == 'remove'){
        that.removeType = false;
        taht.removeID = '';
      }
    },

    async saveSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请输入名称！');
        return false;
      }
      try {
        const response = await savePracticeType(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        name:'',
      }
    },

    async switchChange(e){
      var that = this;
      var obj = {
        id:e.id,
        publish_status:e.publish_status==false?0:1,
      };
      try {
        const response = await updatePracticeTypeStatus(obj,this.token);
        if(response.code == 200){
          that.$message('发布状态修改成功！');
          that.getList();      
        } else {
          that.$message(response.msg);
          e.publish_status = !e.publish_status;
        }
      } catch (error) {
        that.$message(error);
        e.publish_status = !e.publish_status;
      }
    },
  }

  
};
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 5 );
  }

  .btn-remove,
  .btn-revise{
    background-image: url(~@/assets/images/btn-revise.png);
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
    display: inline-block;
    vertical-align: top;
  }

  .btn-remove{
    background-image: url(~@/assets/images/btn-remove.png);
    margin-left: 50px;
  }

  .MobelBox{
    padding: 40px;
    box-sizing: border-box;
    width: 100%;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox textarea{
    width: 80%;
    height: 65px;
    background-color: #F5F5F5;
    border-radius: 16px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: right;
  }

  .write-btnBox .btn{
    width: 120px;
    height: 56px;
    line-height: 56px;
    border-radius: 16px;
    color: #fff;
    background-color: #6E2FFF;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 40px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

.msgBox .title {
  text-align: center;
  margin-bottom: 50px;
}

.btn-import{
  display: inline-block;
  vertical-align: top;
}

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/speech/examType.vue